import { Box } from '@coolblue-development/freddy';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
export const PropositionBarContainer = styled(Box) `
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
const slideInOut = keyframes `
  0% {
    transform: translateX(100vw);
  }
  6.6% {
    transform: translateX(0);
  }
  33.3% {
    transform: translateX(0);
  }
  40% {
    transform: translateX(-250vw);
  }
  100% {
    transform: translateX(-250vw);
  }`;
export const Ticker = styled('div') `
  transform: translateX(100%);
  min-width: 100vw;
  width: 100vw;
  text-align: center;
  animation: ${slideInOut} 15s ease-in-out infinite;
  animation-delay: ${props => props.$index * 5}s;

  ${props => (props.$index === 1 || props.$index === 2) &&
    `
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  `}
`;
//# sourceMappingURL=StyledComponents.js.map